import { useSuspenseQuery } from '@tanstack/react-query';
import { goodsService } from 'shared/src/api';
import { useGoodsSno } from '../../../../../hooks/useGoodsSno';
import { queryKey } from '../../../../../constant/queryKey';

export const useGoodsReviewsPhotoFeeds = () => {
  const sno = useGoodsSno();
  return useSuspenseQuery({
    queryKey: queryKey.goodsReviewsPhotoFeeds(sno),
    queryFn: () => goodsService.getGoodsReviewsPhotoFeeds(sno),
  });
};